import { render } from "./airdrop.vue?vue&type=template&id=5f49a077&scoped=true&ts=true"
import script from "./airdrop.vue?vue&type=script&lang=ts"
export * from "./airdrop.vue?vue&type=script&lang=ts"

import "./airdrop.vue?vue&type=style&index=0&id=5f49a077&scoped=true&lang=css"
import "./airdrop.vue?vue&type=style&index=1&id=5f49a077&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f49a077"]])

export default __exports__